import { Component, ViewChild,OnInit} from '@angular/core';
import { DxFormComponent } from 'devextreme-angular';
import { HttpClient } from '@angular/common/http'; 
import { Configuration } from '../../../app.constants';
import {RegistrationService,Registration,Gender}from  './../../services/registration.service';
import {formatDate} from '@angular/common';
import {HelperService} from '../../../shared/services/helper.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { AuthService, AppInfoService, PortalStudentLogIn } from '../../../shared/services';
import { AppConfigService } from '../../../app-config.service';
import { Physicaldisability } from 'src/app/registration/services/physicaldisability.service';

@Component({
  selector: 'registrationform',
  templateUrl: './registrationform.component.html',
  styleUrls: ['./registrationform.component.scss'],
  providers:[RegistrationService,HelperService]
})
export class RegistrationformComponent implements OnInit {
  @ViewChild(DxFormComponent) myform:DxFormComponent;
  password = "";
  public headerLabel :string ="Registration";
  passwordOptions: any = {
      mode: "password",
      value: this.password
  };
  items:string[];
  buttonOptions: any = {
    text: "Submit",
    type:  "success",
    useSubmitBehavior: true,
  height:40,
  width:200,
  OnClick:'saveRecord'
}
RegistrationData:Registration;
PhysicalD: Physicaldisability[];
isValid:boolean;
isVisible: boolean = true;
isVisible1: boolean = false;
isVisible2: boolean = false;
isVisible3:boolean=false;
isdisable:boolean=true;
dataSource:any;
dataSource1:any;
dataSource2:any;
dataSourceMobOTP:any;
errorMessage: string[] = new Array(); 
now: Date = new Date();
maxDate: Date = new Date();
Genderproducts: any;
OTPdisabled:boolean=true;
OTPdisabledemail:boolean=true;
isReturn:boolean=false;
popupVisible:boolean=false;
disabledDates: Date = new Date();
btnsubDis:boolean=true;
btnVerifydis:boolean=true;
btnVerifydisemail:boolean=true;
maxAge:number;
Mobdisabled:boolean=false;
emailDisabled=false;

OTPVerifySuccessMob:boolean=false;
OTPVerifySuccessEmail:boolean=false;
isStyle:string="{'style': 'text-transform: uppercase'}";
SaveBtnDisabled:boolean=false;
PRNdata:any;
namePattern: any = /^[^0-9]+$/;
private sub: any;
prefixdata = [
  { StudentTitle : 'Mr.' },
  { StudentTitle : 'Mrs.' },
  { StudentTitle : 'Ms.' },
  { StudentTitle : 'Mx.' },
]

ExternalFlagdata = [{ 
  ExternalFlagName:"No",
  ExternalFlag:"N"
},
{ 
  ExternalFlagName:"Yes",
  ExternalFlag:"Y"
}];

passwordComparison = () => {
  return this.myform.instance.option("formData").Password;
};
passwordlengthComparison=()=>{
 if(this.myform.instance.option("formData").Password.length<8){
  console.log(this.myform.instance.option("formData").Password.length);
 return true;
 }

};
  selectedtype: string;
  //Configuration: any;
  StudeMailId: any;
  logindatasource: PortalStudentLogIn[];
  isLogin: boolean;
  Password: string;
  CaptchaInput: string;
  LoadImg: boolean;
  formdatasource: any;
  switchLanguage: any;
  formdatasource1: any;
  StudeMailId1: any;
  StuPortal: any;
  check: number;
  Password1: any;
  LoginAccessdatasource: PortalStudentLogIn[];
  capatchaTest: boolean;
ChangeMobile(e)
{
   this.btnsubDis=true;
}
checkComparison() {
  return true;
}

Queset:string[]=[
  "what is your favorite social media website",
  "What is your first mobile number ",
  "what is your pet name ",
  "what was the name of your primary school  ",
  "Who is your favorite actor, musician, or artist "
];

  intervalId = 0;
  message = '';
  seconds = 11
  btnGenOTP:boolean=false;
  btnGenOTPemail:boolean=false;
  genOTPmsg:string="Generate OTP";

  txtEmailOTP:string="Generate OTP";
  timeString: string;
  // duration = 10*60;
  duration = 5;
  newSeconds = "--";
  minutes = "--";
  clockDisplay: string;
  interval: any;
  showMobileTimer=false;
  showEmailTimer=false;
  Universitydata:any;
  oldStudent:string;
  PRNNo:string;
  oldStudentflag:boolean=false;
  registrationType:any;
  Pattern1: any =/^[^<>]+$/;
  strength:number;
  Rules1:any= /^[^<>]+$/
  public logoPath :string="";
  LanguageLabel:any;
  htmlcontent:string;
  disabledWithPRN:boolean=false;

constructor(private http:HttpClient,
  private router: Router,private route: ActivatedRoute,
  private RegistrationService:RegistrationService, 
  private authService: AuthService, 
  private configuration: Configuration,
  private helperService:HelperService,private Location:Location,
  private appConfigService : AppConfigService ){
   this.maxDate = new Date(this.maxDate.setFullYear(this.maxDate.getFullYear() - 14));
    this.Genderproducts= this.RegistrationService.getGenders();
    this.registrationType=this.RegistrationService.getRegistrationType();
    this.keyPressAction = this.keyPressAction.bind(this);
    this.logoPath = this.appConfigService.LogoPath;
 }
 
 keyPressAction(e){
  console.log(e);
  let keyCode = e.event.keyCode;
  let value=e.event.key;
  if(!this.Pattern1.test(value)){
    event.preventDefault();
    return false;
  }
  if(keyCode==60||keyCode==62){
    event.preventDefault();
    return false;
    
    }
 }
 
verifyAge()
{
    this.RegistrationService.VerifyAge(this.RegistrationData.StudentBirtHDate)
    .subscribe((data: Registration[]) => this.dataSource = data,
      err => {
                  this.errorMessage=this.helperService.getErrorMessage(err);
             },
       () => {
                  //console.log(this.dataSource[0]);
             }); 
 }
 clearTimer() { 
   clearInterval(this.intervalId); 
 }
 onPasswordStrengthChanged(strength) {
 this.strength=strength;
}
  ngOnInit() {
    debugger
    this.LanguageLabel =this.configuration.LanguageLabel[0];
    for (var i = 0; i < this.configuration.progoramlist.length; i++) {
      if(this.configuration.progoramlist[i].AccessPath=="registrationform"){
        if(this.configuration.SelectedLanguage=="En" && this.configuration.progoramlist[i].InStructionInDevnagri=="") {
          this.htmlcontent=this.configuration.progoramlist[i].Instruction;
        }else if(this.configuration.SelectedLanguage!="En" && this.configuration.progoramlist[i].InStructionInDevnagri!="") { 
          this.htmlcontent=this.configuration.progoramlist[i].InStructionInDevnagri;
        }else{
          this.htmlcontent=this.configuration.progoramlist[i].Instruction;
        }
      }
    }
    this.isStyle="{'style': 'text-transform: uppercase'}";
   if(!this.configuration.RegistrationConfirm){
      this.router.navigate(['/checklist-registration-info']); 

    }
    debugger
    this.sub = this.route.queryParams.subscribe(params => {
      this.oldStudent = params["OldStudent"];
      this.PRNNo =  params["UniverSityPRNNO"];
    });
    if(this.oldStudent=="Y"){
      this.oldStudentflag=true;
    }
    if(this.oldStudent=="N"){
      this.oldStudentflag=false;
    }
       this.cleardata();
       this.errorMessage=[] 
                  
       this.authService.GetSystemUniversityForFlag("Flag5")
       .subscribe((data: PortalStudentLogIn[]) => this.Universitydata = data,
       error => {
         //alert(error);
       },
       () => {
         ;
         if(this.Universitydata.length > 0){
         this.configuration.UniversityFlag=this.Universitydata[0].Flag;
         }
         
          if ((this.PRNNo!="") && (this.PRNNo!=null) &&  (this.PRNNo!=undefined))
          {            
            this.RegistrationService.GetStudentByUniverSityPRNNO(this.PRNNo)
            .subscribe((data:Registration[]) => this.dataSource = data,
            error => {
            alert(error);
            },
            () => {debugger  
              if(this.dataSource.length>0){ 
              this.RegistrationData = this.dataSource[0];  
              this.RegistrationData.StudentBirtHDate = this.dataSource[0].StudentBirthDate;
              this.disabledWithPRN =true;
              }
              else{
                this.disabledWithPRN =false;
              }
            });
          }
       });  
  }
  cleardata(){
    this.RegistrationData={
    StudentTitle:null,
    StuPoartlaID: null,
    StudeMailId: null,
    FirstName:null,
    LastName: null,
    MiddleName: "",
    StuGender: null,
    MobileNo: null,
    EmailID:null,
    StudentMothersName: "",
    StudentBirtHDate:null,
    Password: null,
    CollegeID:null,
    StudentID:null,
    MoblieOTP: null,
    EmailOTP: null,
    Question1A:null,
    Question2A: null,
    Question3A: null,
    Question4A: null,
    Question5A: null,
    confirmPassword:null,
    PreExamOtpId:null,
    StudentRegType:null,
    PRNNO:null,
    UniverSityPRNNO:null,
    StudentName:null,
    ExternalFlag:null,
    PhysicalDisabilityID:0
    }
    }

    generatemobOTP(){
     
      this.Mobdisabled=false;
      if( (this.RegistrationData.MobileNo==null) ||  (this.RegistrationData.MobileNo==""))
          {
            this.helperService.showWarningMessage("First Enter Mobile No");
            return false;
           }
           var moblen = new String(this.RegistrationData.MobileNo) ;
           if (moblen.length!=10)
              {
                 this.helperService.showWarningMessage("Enter 10 digit valid Mobile No");
                 this.RegistrationData.MobileNo="";
                return false;
                }
           this.btnsubDis=true;
           this.RegistrationData.MoblieOTP="";
            this.RegistrationService.VerifyDuplicateMob(this.RegistrationData.MobileNo,this.configuration.CollegeID)
            .subscribe((data: Registration[]) => this.dataSource = data,
         err => {
                    this.btnsubDis=false;
                    var error = this.helperService.getErrorMessage(err)
                    alert(error);
              },
             () => {
              if (this.dataSource==1)
              {
                  this.helperService.showWarningMessage("Duplicate/Invalid Mobile No.");
                  this.RegistrationData.MobileNo="";
                  this.isReturn=false;
              }
              else
              {
                  this.btnGenOTP = true;
                  this.showMobileTimer=true;
                  this.timeCountDown(this.configuration.OTPTimeLimt);
                  this.RegistrationService.GenerateMobOTP(this.RegistrationData.MobileNo,this.configuration.CollegeID)
                    .subscribe((data: Registration[]) => this.dataSource = data,
                    err => {
                      var error = this.helperService.getErrorMessage(err)
                      alert("error");
                      this.btnVerifydis=true;
                      this.OTPdisabled=true;
                      this.btnGenOTP = false;
                      },
                      () => {
                        this.start();
                        console.log(this.dataSource[0]);
                        this.RegistrationData.PreExamOtpId=this.dataSource[0].PreExamOtpId;
                        if(this.configuration.SmsEmailSendOTPFlag =="N"){
                          this.RegistrationData.MoblieOTP="12345";
                        }
                        this.btnVerifydis=false;
                        this.OTPdisabled=false;
                        this.isVisible2=true;
                        this.Mobdisabled=true;
                      }); 

              }
         });

    }
  start() {
     this.countDown(); 
  }
  private countDown() {
    this.clearTimer();
    this.intervalId = window.setInterval(() => {
      this.seconds -= 1;
      if (this.seconds === 0) {
      } else {
        if (this.seconds < 0) { this.seconds = 5; } 
        this.Mobdisabled=false;
        this.btnGenOTP = false;
        this.genOTPmsg ="Resend OTP";
      }
    }, this.configuration.OTPTimeLimt); //    }, 60000);
  }
  generateemailOTP(){
    this.isVisible1=false;
    debugger;
    this.RegistrationService.GenerateEmailOTP( this.RegistrationData.MobileNo,this.RegistrationData.StudeMailId,this.RegistrationData.PreExamOtpId,this.configuration.CollegeID)
      .subscribe((data: Registration[]) => this.dataSource1 = data,
      err => {
          this.helperService.showWarningMessage("This Email already present please enter another"); 
       // this.errorMessage=this.helperService.getErrorMessage(err);
     },
         () => {
           debugger;
          console.log(this.dataSource1[0]);
          this.isVisible1=true;

         }); 
   
  }
  verifymobOTP(){
    if( (this.RegistrationData.MobileNo==null) ||  (this.RegistrationData.MobileNo==""))
      {
           this.helperService.showWarningMessage("First Enter Mobile No");
           return false;
      }
      if( (this.RegistrationData.MoblieOTP==null) ||  (this.RegistrationData.MoblieOTP==""))
      {
        this.helperService.showWarningMessage("First Enter Mobile OTP");
        return false;
       }
    this.RegistrationService.VerifyMobOTP(this.RegistrationData.MobileNo,this.RegistrationData.MoblieOTP,this.configuration.CollegeID)
    .subscribe((data: Registration[]) => this.dataSourceMobOTP = data,
    err => {
        this.helperService.showWarningMessage("Wrong OTP");   
        this.RegistrationData.MoblieOTP="";
      },
      () => {debugger
            if(this.configuration.SmsEmailSendOTPFlag =="N"){
                if(this.RegistrationData.MoblieOTP =="12345"){
                  this.btnVerifydis=true;
                  this.OTPdisabled=true;
                  this.btnsubDis=false;
                  this.helperService.showSuccessMessage("OTP Verified"); 
                  this.OTPVerifySuccessMob=true;  
                  this.isVisible2=false
                  console.log(this.dataSourceMobOTP[0]);
                }
            }else{
                if ((this.dataSourceMobOTP==0) )
                    {
                      this.helperService.showWarningMessage("Wrong OTP");   
                      this.RegistrationData.MoblieOTP="";
                    }
                    else{
                      this.btnVerifydis=true;
                      this.OTPdisabled=true;
                      this.btnsubDis=false;
                      this.helperService.showSuccessMessage("OTP Verified"); 
                      this.OTPVerifySuccessMob=true;  
                      this.isVisible2=false
                      console.log(this.dataSourceMobOTP[0]);
                    }
            }
      }); 
      this.isdisable=false;
  }
  verifyOTPemail(){

    if( (this.RegistrationData.StudeMailId==null) ||  (this.RegistrationData.StudeMailId==""))
      {
           this.helperService.showWarningMessage("First Enter Email");
           return false;
      }
      if( (this.RegistrationData.EmailOTP==null) ||  (this.RegistrationData.EmailOTP==""))
      {
        this.helperService.showWarningMessage("First Enter Email OTP");
        return false;
       }
       this.RegistrationService. VerifyEmailOTP(this.RegistrationData.MobileNo, this.RegistrationData.StudeMailId,this.RegistrationData.EmailOTP,this.configuration.CollegeID)
      .subscribe((data: Registration[]) => this.dataSourceMobOTP = data,
      err => {
          this.helperService.showWarningMessage("Wrong OTP");   
          this.RegistrationData.EmailOTP="";
        },
      () => {
            //**change for suyog 29-11-2019 */
            if(this.configuration.SmsEmailSendOTPFlag =="N"){
                if(this.RegistrationData.EmailOTP =="12345"){
                  this.btnVerifydisemail=true;
                  this.OTPdisabledemail=true;
                  this.btnGenOTP=true;
                  this.btnGenOTPemail=true;
                  this.btnsubDis=false;
                  this.helperService.showSuccessMessage("Email OTP Verified");   
                  this.OTPVerifySuccessEmail=true;
                  this.isVisible3=false;
                  console.log(this.dataSourceMobOTP[0]);
                }
            }else{
                if ((this.dataSourceMobOTP==0) )
                    {
                      this.helperService.showWarningMessage("Wrong OTP");   
                      this.RegistrationData.EmailOTP="";
                    }
                    else{
                      this.btnVerifydisemail=true;
                      this.OTPdisabledemail=true;
                      this.btnGenOTP=true;
                      this.btnGenOTPemail=true;
                      this.btnsubDis=false;
                      this.helperService.showSuccessMessage("Email OTP Verified");   
                      this.OTPVerifySuccessEmail=true;
                      this.isVisible3=false;
                      console.log(this.dataSourceMobOTP[0]);
                    }
            }
      }); 
      this.isdisable=false;
  }

  changeCheck(event){
    debugger;
    if(event.value == true){
      this.RegistrationData.ExternalFlag = "Y";
    }else{
      
    }
  }

  saveRecord() {
   debugger;
    this.isValid = this.myform.instance.validate().isValid;
    if(this.isValid == true) {
      if(this.oldStudent=="N"){
        this.RegistrationData.StudentRegType="N";
        this.RegistrationData.PRNNO="";
        this.RegistrationData.PhysicalDisabilityID=0;
      }
      if(this.oldStudent=="Y"){
        if(this.RegistrationData.StudentRegType==undefined||this.RegistrationData.StudentRegType==null||this.RegistrationData.StudentRegType==""){
          this.helperService.showWarningMessage("Select  Registration Type");
          return false;
        }
        if(this.RegistrationData.PRNNO==undefined||this.RegistrationData.PRNNO==null||this.RegistrationData.PRNNO==""){
          this.helperService.showWarningMessage("Enter PRN NO");
          return false;
        }
        
      }
      if ((this.PRNNo!="") || (this.PRNNo!=null))
      {
        this.RegistrationData.PRNNO = this.PRNNo;
      }

      if(this.configuration.UniversityFlag=="Y"){
        if(this.RegistrationData.StudeMailId==undefined||this.RegistrationData.StudeMailId==null){
          this.RegistrationData.StudeMailId=="";
        }
        if(this.RegistrationData.EmailOTP==undefined||this.RegistrationData.EmailOTP==null){
          this.RegistrationData.EmailOTP=="";
        }
      }
      if(this.configuration.UniversityFlag=="N"){
        /* if(this.RegistrationData.StudeMailId==undefined||this.RegistrationData.StudeMailId==null||this.RegistrationData.StudeMailId==""){
          this.helperService.showWarningMessage("Enter Email");
          return false;
        } 
        if(this.RegistrationData.EmailOTP==undefined||this.RegistrationData.EmailOTP==null||this.RegistrationData.EmailOTP==""){
          this.helperService.showWarningMessage("Enter Email OTP");
          return false;
        } */
      }

    if( (this.RegistrationData.MobileNo==null) ||  (this.RegistrationData.MobileNo=="")){
      this.helperService.showWarningMessage("First Enter Mobile No");
      return false;
    }
    var moblen = new String(this.RegistrationData.MobileNo) ;
      if (moblen.length!=10)
         {
          this.helperService.showWarningMessage("Enter 10 digit valid Mobile No");
          this.RegistrationData.MobileNo="";
         return false;
      }
    this.isValid = this.myform.instance.validate().isValid;
    this.RegistrationData.Question1A="";
    this.RegistrationData.Question2A= "";
    this.RegistrationData.Question3A="";
    this.RegistrationData.Question4A="";
    this.RegistrationData.Question5A= "";

    if(this.RegistrationData.ExternalFlag==undefined||this.RegistrationData.ExternalFlag==null||this.RegistrationData.ExternalFlag=="" ||this.RegistrationData.ExternalFlag=="N"){
      this.RegistrationData.ExternalFlag="N";
    }

    if(this.RegistrationData.ExternalFlag =="Y"){
      this.RegistrationData.ExternalFlag="Y";
    }

    if(this.isValid == true) {
        if(this.OTPVerifySuccessMob==false){
          this.helperService.showWarningMessage("Mobile Verification is not done");
          return false;
        }
        if(this.configuration.UniversityFlag=="N"){
        /* if(this.OTPVerifySuccessEmail==false){
          this.helperService.showWarningMessage("Email Verification is not done");
          return false;
        } */
      }
        this.errorMessage=[];   
         if (this.RegistrationData.MiddleName==null){
              this.RegistrationData.MiddleName="";
             }
             if (this.RegistrationData.StudentMothersName==null){
              this.RegistrationData.StudentMothersName="";
             }
             
          this.RegistrationData.StuPoartlaID = 0;
          var str1 = formatDate(this.RegistrationData.StudentBirtHDate, 'dd/MMM/yyyy hh:mm:ss', 'en');
          this.RegistrationData.StudentBirtHDate=str1;
          if(this.RegistrationData.StudentID==null || this.RegistrationData.StudentID==undefined){
            this.RegistrationData.StudentID= 0;
          }
           //this.RegistrationData.StudentID= StudentID;
           this.SaveBtnDisabled=true;
           if(this.oldStudent=="Y"){
            this.RegistrationService.GetCheckPRNCount(this.RegistrationData.PRNNO)
            .subscribe((data: Registration[]) => this.PRNdata = data,
            err => {
              },
              () => {
                  if(this.PRNdata==1) {
                    this.helperService.showWarningMessage("PRN No. already exist");
                    return false;
                  }else{
                    this.savemethod();
                  }
              }); 
           }
           else{
              this.savemethod();
           }
      } 
      
    }
   //this. loginForStudentProfile();
   }
   savemethod(){
    this.RegistrationData.Password= window.btoa(this.RegistrationData.Password);
    this.RegistrationData.CollegeID = this.configuration.CollegeID;
    this.RegistrationService.CheckEmailDuplicate(this.RegistrationData.StudeMailId)
    .subscribe((data: Registration[]) => this.dataSource = data,
    err => {
      this.SaveBtnDisabled=false;
      },
    () => {
      debugger
      if(this.dataSource==undefined || this.dataSource.length==0){
          this.RegistrationService.save(this.RegistrationData)
          .subscribe(value => {
            this.onSuccessSave();
          },
            err => {
              var error = this.helperService.getErrorMessage(err)
              alert(error);
              this.SaveBtnDisabled=false;   
            },
            () => {
            
            });
      }else{
        this.helperService.showWarningMessage("Email Id already exist");
        this.SaveBtnDisabled=false;
        return false;
      }
    });
   }
   onSuccessSave() {
     debugger;
    this.helperService.showSuccessMessage("You have successfully Registered on Core Campus"); 
    this.SaveBtnDisabled=false;   
   //this.router.navigate(['/login-form']);  
  //this.router.navigate(['studentportal/studentprofile1']); 
  this. loginForStudentProfile();
   }

   generateOTPemail(){
        if( (this.RegistrationData.StudeMailId==null) ||  (this.RegistrationData.StudeMailId==""))
        {
          this.helperService.showWarningMessage("First Enter Email ID");
          return false;
        }
        if(this.OTPVerifySuccessMob==false){
          this.helperService.showWarningMessage("First Verify your Mobile No.");
          return false;
        }
         this.btnsubDis=true;
         this.RegistrationData.EmailOTP="";
          this.RegistrationService.VerifyDuplicateEmail( this.RegistrationData.StudeMailId)
            .subscribe((data: Registration[]) => this.dataSource = data,
            err => {
                  var error = this.helperService.getErrorMessage(err)
                  alert(error);
            },
           () => {
            if (this.dataSource==1)
            {
                this.helperService.showWarningMessage("Duplicate/Invalid Email ID");
                this.RegistrationData.StudeMailId="";
                this.isReturn=false;
            }
            else
            {
                this.btnGenOTPemail = true;
                this.showEmailTimer=true;
                this.emailDisabled=true;
                this.timeCountDown(this.configuration.OTPTimeLimt);
                this.RegistrationService.GenerateEmailOTP(this.RegistrationData.MobileNo,this.RegistrationData.StudeMailId,this.RegistrationData.PreExamOtpId,this.configuration.CollegeID)
                  .subscribe((data: Registration[]) => this.dataSource = data,
                  err => {
                    var error = this.helperService.getErrorMessage(err)
                    alert("error");
                    this.btnVerifydisemail=true;
                    this.btnGenOTPemail = false;
                    },
                    () => {
                       this.isVisible3=true;
                       this.btnGenOTPemail = false;
                       this.btnVerifydisemail=false;
                       this.OTPdisabledemail=false;
                       if(this.configuration.SmsEmailSendOTPFlag =="N"){
                        this.RegistrationData.EmailOTP="12345";
                      }
                    }); 
            }
       });
  }

  redirectToLogin(){
    this.router.navigate(['/login-form']);  
  }



  timeCountDown(duration:number) {
    this.duration=duration;
    
    if (this.duration > 0) {
      this.interval = setInterval(() => {
      this.duration = this.duration - 1;
        if (this.duration <= 0) {
          if(this.showMobileTimer===true){
          this.btnGenOTP = false;
          this.genOTPmsg ="Resend OTP";        
          this.Mobdisabled=false;
          this.showMobileTimer=false;
          this.btnVerifydis=true;
          this.OTPdisabled = true;
          }
          else if(this.showEmailTimer===true){
          this.btnGenOTPemail = false;
          this.txtEmailOTP ="Resend OTP";
          this.emailDisabled=false;

          this.showEmailTimer=false;

          this.btnVerifydisemail=true;
          this.OTPdisabledemail = true;
          }
          clearInterval(this.interval);
        }
        var TimeDuration = this.configuration.OTPTimeLimt;
        if (this.duration % 100 < 10) {
          this.newSeconds = "0" + this.duration % 100;
        } else {
          this.newSeconds = (this.duration % 100).toString();
        }

        if (this.duration / 100 < 10) {
          this.minutes = "0" + parseInt("" + this.duration / 100, 10);
        } else {
          this.minutes = "" + parseInt((this.duration / 100).toString(), 10);
        }

        //this.clockDisplay = this.minutes + " : " + this.newSeconds + "secs";
        this.clockDisplay =  this.newSeconds + "secs";
      }, 1000);
    }
  }

//=============================

  loginForStudentProfile(){
    //if(this.selectedtype=="Student")
    //{
      debugger;
      this.configuration.IsParrent=false;
      this.authService.GetSystemUserLogByLoginName(this.RegistrationData.MobileNo)
      .subscribe((data: PortalStudentLogIn[]) => this.logindatasource = data,
      error => {
        alert(error);
        this.isLogin=false;
        this.isLogin=false;
        this.StudeMailId= "";
        this.Password= "";
        this.CaptchaInput ="";
        this.RefreshCaptchaClick(event);
        this.LoadImg=false;
        },
        () => {
        
          if(this.logindatasource.length>0 && this.logindatasource[0].Checkflag=="N"){
                this.isLogin=false;
                this.StudeMailId= "";
                this.Password= "";
                this.CaptchaInput ="";
                this.RefreshCaptchaClick(event);
                this.LoadImg=false;
                //alert("User already logged in the system.");
                this.helperService.showWarningMessage("User already logged in the system.");
                return;
            }
            else{
              this.authService.GetCheckUserLoginAccessForPortal(this.RegistrationData.MobileNo)
              .subscribe((data: PortalStudentLogIn[]) => this.LoginAccessdatasource = data,
              error => {
                this.LoadImg=false;
              },
              () => {
               if(this.LoginAccessdatasource.length>0 &&this.LoginAccessdatasource[0].IsAccessible==false){
                  // alert("Your Account is Locked.You can login after 60 Minutes.");
                   this.helperService.showWarningMessage("Your Account is Locked.You can login after 60 Minutes.");
                   this.LoadImg=false;
               }
               else{
                this.capatchaTest=true;
                if(this.capatchaTest==true){
                  this.StudeMailId= window.btoa(this.RegistrationData.MobileNo);
                  this.Password= this.RegistrationData.Password;
                  this.isLogin=true;
                  this.LoadImg=false;
                  }
                this.authService.logIn(this.StudeMailId, this.Password)
                .subscribe((data: PortalStudentLogIn[]) => this.formdatasource = data,
                 error => {
                   alert(error);
                   this.isLogin=false;
                   this.isLogin=false;
                   this.StudeMailId= "";
                   this.Password= "";
                   this.CaptchaInput ="";
                   this.RefreshCaptchaClick(event);
                   this.LoadImg=false;
                 },
                 () => {debugger
                  if(this.formdatasource.length > 0)
                  {
                   
                        let navigationExtras: NavigationExtras = {
                          queryParams: {
                             "StudentID" : this.formdatasource[0].StudentID ,
                             "StudeMailId" : this.formdatasource[0].StudeMailId,
                             "StuPoartlaID":this.formdatasource[0].StuPoartlaID,   
                             "StuGender":this.formdatasource[0].StuGender,
                             "MobileNo":this.formdatasource[0].MobileNo,
                             "PhotoPath":this.formdatasource[0].PhotoPath,
                             "SignPath":this.formdatasource[0].SignPath,
                           
                            "PhysicalDisabilityID":0

                              }
                            }
                            ;
                            this.configuration.Password = null ;
                            this.configuration.StudentID = null ;
                            this.configuration.PhotoPath = null ;
                            this.configuration.SignPath = null ;
                            this.configuration.PRNNo=null;
                            this.configuration.StuPoartlaID =  this.formdatasource[0].StuPoartlaID ;
                            this.configuration.portalopen ="";
                            this.configuration.PhysicalDisabilityID= this.formdatasource[0].PhysicalDisabilityID ;
                            this.configuration.Password = this.Password1;
                            this.configuration.StudentID = this.formdatasource[0].StudentID ;
                            this.configuration.PhotoPath = this.formdatasource[0].PhotoPath ;
                            this.configuration.SignPath = this.formdatasource[0].SignPath ;
                            this.configuration.StuPoartlaID = this.formdatasource[0].StuPoartlaID ;
                            this.configuration.AcademicInstanceID = this.formdatasource[0].AcademicInstanceID;
                            this.configuration.ExamInstanceID = this.formdatasource[0].ExamInstanceID;
                            this.configuration.prospectshow=this.formdatasource[0].prospectshow;
                            this.configuration.ExternalFlag=this.formdatasource[0].ExternalFlag;
                            this.authService.logNewRegistration(navigationExtras, this.formdatasource[0].LastName + ' ' + this.formdatasource[0].FirstName );
                            this.switchLanguage(this.Defaultlang);
                            this.authService.GetPRNNoByStudentID(this.formdatasource[0].StudentID)
                                .subscribe((data: PortalStudentLogIn[]) => this.formdatasource = data,
                                error => {
                                  alert(error);
                                 
                                },
                                () => {
                                  this.configuration.PRNNo=this.formdatasource1[0].PRNNO;
                                  
                                });
                                this.LoadImg=false;
                          }
                     
                    else{
                      this.isLogin=false;
                      this.StudeMailId= "";
                      this.Password= "";
                      this.CaptchaInput ="";
                      this.RefreshCaptchaClick(event);
                      //alert("Invalid UserName Or Password");
                      this.helperService.showWarningMessage("Invalid UserName Or Password.");
                      this.LoadImg=false;
                      this.check=this.check+1;
                      if(this.check==5){
                        this.StuPortal=[];
                    this.StuPortal.StudeMailId=this.StudeMailId1;
                      this.StuPortal.Minutes=59;
                        this.authService.PostSystemUserAfterLoginForPortal(this.StudeMailId)
                        .subscribe(value => {
                        },
                        err => {
                        },
                        () => {
                         
                        });
                      }
                      return;
                    }
                 });
               }
              });
            }
         });
    //}
  }
  Defaultlang(Defaultlang: any) {
    throw new Error('Method not implemented.');
  }
  RefreshCaptchaClick(event: Event) {
    throw new Error('Method not implemented.');
  }
}
